module.exports = __webpack_public_path__ + "right.r-tNdYyC.svg";